<script setup lang="ts">
import { computed } from 'vue';
import GenericModal from '@shared/ui/components/modals/GenericModal.vue';
import ButtonComponent from '@shared/ui/components/ButtonComponent.vue';
import { useAuthStore } from '@/stores';
import { useTenantStore } from '@features/tenant/store/tenant';

interface Props {
  modelValue: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
}>();

const authStore = useAuthStore();
const tenantStore = useTenantStore();

const supportOwner = computed(() => tenantStore.brandName || 'la plataforma');

const show = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});

function handleClose() {
  authStore.accountBlockedReason = '';
}

function dismiss() {
  show.value = false;
  handleClose();
}
</script>

<template>
  <GenericModal
    v-model="show"
    size="md"
    bg-class="bg-backgrounds-darkgrey"
    title="Cuenta bloqueada permanentemente"
    @on:close="handleClose"
  >
    <div class="flex w-full flex-col gap-3 pt-4">
      <p class="text-sm text-white/90">
        Tu cuenta ha sido bloqueada permanentemente por infringir las normas de
        la plataforma.
      </p>
      <p
        v-if="authStore.accountBlockedReason"
        class="rounded-lg bg-black/30 p-3 text-sm text-white/75"
      >
        <span class="font-semibold text-white">Motivo:</span>
        {{ authStore.accountBlockedReason }}
      </p>
      <p class="text-sm text-white/75">
        Si crees que se trata de un error, comunícate con el soporte de
        {{ supportOwner }} para que revisen tu caso.
      </p>
    </div>
    <template #footer>
      <div class="mt-2 flex w-full flex-wrap justify-end gap-2">
        <a
          v-if="tenantStore.supportContact"
          :href="tenantStore.supportContact.href"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center rounded-lg border border-white/20 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-white/10"
        >
          {{ tenantStore.supportContact.label }}
        </a>
        <ButtonComponent type="button" variant="primary" @click="dismiss">
          Entendido
        </ButtonComponent>
      </div>
    </template>
  </GenericModal>
</template>

<style scoped></style>
